import { Component, OnInit } from '@angular/core';
import { TrackingService } from 'src/app/Tracking.service';

@Component({
  selector: 'app-download-forms',
  templateUrl: './download-forms.component.html',
  styleUrls: ['./download-forms.component.scss'],
})
export class DownloadFormsComponent implements OnInit {
  constructor(private tracking: TrackingService) {}

  ngOnInit(): void {}

  trackForm(name){
    this.tracking.pushEvent("download_forms", {form_name: name});
  }
}
